import { render } from "./BullDetailView.vue?vue&type=template&id=5fb13b04&scoped=true&ts=true"
import script from "./BullDetailView.vue?vue&type=script&lang=ts"
export * from "./BullDetailView.vue?vue&type=script&lang=ts"

import "./BullDetailView.vue?vue&type=style&index=0&id=5fb13b04&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fb13b04"]])

export default __exports__